import ToggleSwitch from "../../../../../shared/ToggleSwitch";

/**
 * Notification events table with ON/OFF toggles and optional EoM/EoY radios.
 *
 * @param {object} props
 * @param {ReadonlyArray<object>} props.events
 * @param {string | undefined} props.selectedLanguage
 * @param {(eventKey: string, isSelected: boolean) => void} props.onEventToggle
 * @param {(params: { eventTitle: string, eventType: string, isEoy: boolean }) => void} props.onEoyChange
 * @returns {import('react').JSX.Element}
 */
const EventsTable = ({
    events,
    selectedLanguage,
    onEventToggle,
    onEoyChange,
}) => (
    <div className="plan-notification-events-table-wrapper">
        <table className="plan-notification-events-table">
            <thead>
                <tr>
                    <th scope="col">NOTIFICATION</th>
                    <th scope="col">Type</th>
                    <th scope="col">Description of event</th>
                    <th scope="col">DEFAULT EN</th>
                    <th scope="col">DEFAULT EN - SP</th>
                    <th scope="col">
                        <span>ON/OFF</span>
                        <span className="plan-notification-events-table__eoy-label">
                            End of month/End of year
                        </span>
                    </th>
                </tr>
            </thead>
            <tbody>
                {events.map((event) => {
                    const rowKey = `${event.title}:${event.type}`;
                    const showEnglish = selectedLanguage === "English";
                    const showSpanish = selectedLanguage === "English + Spanish";
                    const hasEoyOption = Object.prototype.hasOwnProperty.call(
                        event,
                        "isEOY",
                    );

                    return (
                        <tr key={rowKey}>
                            <td>{event.title}</td>
                            <td>{event.type}</td>
                            <td>{event.description}</td>
                            <td>{showEnglish ? event.defaultEn : "--"}</td>
                            <td>{showSpanish ? event.defaultEnSp : "--"}</td>
                            <td>
                                <div className="plan-notification-events-table__controls">
                                    {hasEoyOption ? (
                                        <div
                                            className="plan-notification-events-table__eoy"
                                            role="radiogroup"
                                            aria-label={`${event.title} EoM or EoY`}
                                        >
                                            <label>
                                                <input
                                                    type="radio"
                                                    name={`${rowKey}-eoy`}
                                                    checked={
                                                        event.isSelected &&
                                                        !event.isEOY
                                                    }
                                                    disabled={!event.isSelected}
                                                    onChange={() =>
                                                        onEoyChange({
                                                            eventTitle: event.title,
                                                            eventType: event.type,
                                                            isEoy: false,
                                                        })
                                                    }
                                                />
                                                EoM
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    name={`${rowKey}-eoy`}
                                                    checked={
                                                        event.isSelected &&
                                                        Boolean(event.isEOY)
                                                    }
                                                    disabled={!event.isSelected}
                                                    onChange={() =>
                                                        onEoyChange({
                                                            eventTitle: event.title,
                                                            eventType: event.type,
                                                            isEoy: true,
                                                        })
                                                    }
                                                />
                                                EoY
                                            </label>
                                        </div>
                                    ) : null}
                                    <ToggleSwitch
                                        aria-label={`Toggle ${event.title}`}
                                        checked={Boolean(event.isSelected)}
                                        onToggle={() =>
                                            onEventToggle(
                                                rowKey,
                                                !event.isSelected,
                                            )
                                        }
                                    />
                                </div>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    </div>
);

export default EventsTable;
